import { render, staticRenderFns } from "./ReCardKBPostNest.vue?vue&type=template&id=7004ee82&scoped=true"
import script from "./ReCardKBPostNest.vue?vue&type=script&lang=js"
export * from "./ReCardKBPostNest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7004ee82",
  null
  
)

export default component.exports